<div [formGroup]="formGroup" class="control control--input control--calendar" [hidden]="hidden">
  <div *ngIf="model.hasLabel" class="control__header">
    <label class="control__header__label" [for]="model.key" [title]="model.label">{{ model.label }}</label>
    <div class="control__header__error" *ngIf="hasError" [title]="error">{{ error }}</div>
  </div>
  <p-calendar appendTo="body"
              [showIcon]="true"
              [styleClass]="classes"
              [readonlyInput]="model.readonly"
              [inputId]="model.key"
              [hideOnDateTimeSelect]="true"
              [placeholder]="model.placeholder"
              [formControlName]="model.key"
              (input)="onInput.emit($event)"
              (focus)="onFocus.emit($event)"
              (blur)="onBlur.emit($event)">
  </p-calendar>
</div>
